
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"#C6DCF5","cx":"12","cy":"12","r":"9"}}),_c('path',{attrs:{"d":"M12 3a8.995 8.995 0 017.685 4.314c-.993 1.033-3.47 1.507-5.185.858-.602.583-.705.83-1.714.83-1.103 0-2.612-1.092-2.796-.654-.802 1.909-1.205 1.984-1.542 1.152-.338-.832-.932-2.99.18-4.322.052-.063 1.3-1.14 2.386-1.146.262-.427.539-.765.824-1.031z","fill":"#809FBF"}}),_c('path',{attrs:{"d":"M10 9l.162 3.585L13 11.095v1.483l3-1.397V16.5H7.656L8 9h2zm1 5h-1v1h1v-1zm2 0h-1v1h1v-1zm2 0h-1v1h1v-1z","fill":"#324A5E","fill-rule":"nonzero"}})])])
          )
        }
      }
    